export const FILE_PRESIGN = 'fileUploads/FILE_PRESIGN';

